<template>
  <div class="ty-main">
    <div class="ty-content">
      <el-row :gutter="20">
        <el-col :span="10">
          <el-card class="box-card" :class="{ 'gfdgjo':(tabIndex === 0), 'dfgf':(tabIndex === 1)}">
            <div class="ty-tabs">
              <template v-for="(item, index) in tabs">
                <div
                  class="tab-item"
                  :key="index"
                  :class="{ active: tabIndex === index }"
                  v-auth="[item.auth]"
                  @click="changeTab(index)"
                >
                  {{ item.title }}
                </div>
              </template>
              <span class="xiao" style=" color: #204A9E;"><span class="mkl" @click="opuj">消息类型说明 ></span></span>
            </div>
            <el-form
              ref="searchForm"
              :model="searchForm"
              label-position="left"
              label-width="80px"
              style="padding: 0 24px;"
              :rules="searchForm"
            >
              <el-form-item label="发送人" v-show="tabIndex === 0">
              <el-radio-group v-model="radio2" style="width: 35%;" @change="uroqwi">
                  <el-radio :label="1" @change="qwedw">员工</el-radio>
                  <el-tooltip
                    v-if="this.ablie === true"
                    class="item"
                    effect="dark"
                    content="请点击右侧重置按钮后才可选择"
                    placement="top-start"
                  >
                  <el-radio disabled>客户</el-radio>
                  </el-tooltip>
                  <el-radio v-else :disabled="ablie" :label="2" @change="huihwi">客户</el-radio>
              </el-radio-group>
                <el-input
                  v-if="radio2 === 1"
                  class="inline-input"
                  v-model="searchForm.sendName"
                  placeholder="请点击选择员工/部门"
                  @focus="openDepartement"
                  clearable
                  @change="kong"
                  @clear="sendNameClear"
                  style="width:50%;"
                ></el-input>
                <el-select
                  v-model="searchForm.receiverName"
                  filterable
                  remote
                  clearable
                  reserve-keyword
                  placeholder="请输入客户名称"
                  :remote-method="receiverRemote"
                  :loading="loading"
                  class="inline-input client-input"
                  style="width:50%;"
                  @focus="kongkong"
                  @clear="qing"
                  v-else
                >
                  <el-option
                    class="juj"
                    v-for="item in freceiverList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                    <img style="border: 1px solid #234C9C;border-radius: 2px;" :src="item.avatar" width="32px" height="32px" />
                    <div class="loh">
                      <span v-if="item.type === 1">{{ item.name }}<span style="color: #46BB36FF;">@微信</span></span>
                      <span v-if="item.type === 2 || item.type === 3">{{ item.name }}<span style="color: #FFC811FF;">@{{ item.corp_name }}</span></span>
                    </div>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发送人" v-show="tabIndex === 1">
                <el-select
                    v-model="searchForm.staffNamea"
                    filterable
                    remote
                    placeholder="请输入离职员工"
                    :remote-method="receiverStaff"
                    :loading="loading"
                    clearable
                    class="inline-input client-input"
                    style="width:100%;"
                    @clear="sendClear"
                    @change="gdsuifhu"
                  >
                    <el-option
                      class="juj"
                      v-for="item in leaveAllList"
                      :key="item.user_id"
                      :label="item.name"
                      :value="item.user_id"
                    >
                    <div style="display: flex;">
                    <!--  <img v-if="item.avatar !== ''" style="border: 1px solid #234C9C;border-radius: 2px;" :src="item.avatar" width="32px" height="32px" />
                      <img v-else style="border: 1px solid #234C9C;border-radius: 2px;" src="../../assets/images/user_avatar2.png" width="32px" height="32px" />-->
                      <div style="margin-left: 5px;line-height: 16px;">
                        <div class="dsfsad">{{ item.name }}</div>
                        <div class="dsfsad01">{{ item.department_name }}</div>
                      </div>
                    </div>
                    </el-option>
                  </el-select>
              </el-form-item>
               <el-form-item label="接收人" v-show="tabIndex === 0">
               <el-radio-group v-model="radio" style="width: 35%;" @change="wqweq">
                  <el-radio :label="1" @change="yiou">员工</el-radio>
                  <el-tooltip
                    v-if="this.isable === true"
                    class="item"
                    effect="dark"
                    content="请点击右侧重置按钮后才可选择"
                    placement="top-start"
                  >
                  <el-radio disabled>客户</el-radio>
                  </el-tooltip>
                  <el-radio v-else :disabled="isable" @change="ipojin" :label="2">客户</el-radio>
              </el-radio-group>
                <el-input
                  v-if="radio === 1"
                  class="inline-input"
                  v-model="searchForm.staffName"
                  placeholder="请点击选择员工/部门"
                  @focus="openDepart"
                  clearable
                  @input="kong"
                  @clear="shouClear"
                  style="width:50%;"
                ></el-input>
                <el-select
                  v-model="searchForm.recName"
                  filterable
                  remote
                  clearable
                  reserve-keyword
                  placeholder="请输入客户名称"
                  :remote-method="receiver"
                  :loading="loading"
                  class="inline-input client-input"
                  style="width:50%;"
                  @input="kong"
                  @focus="kongkong"
                  @clear="qing"
                  v-else
                >
                  <el-option
                    class="juj"
                    v-for="item in freceiverList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  <img style="border: 1px solid #234C9C;border-radius: 2px;" :src="item.avatar" width="32px" height="32px" />
                  <div class="loh">
                    <span v-if="item.type === 1">{{ item.name }}<span style="color: #46BB36FF;">@微信</span></span>
                    <span v-if="item.type === 2 || item.type === 3">{{ item.name }}<span style="color: #FFC811FF;">@{{ item.corp_name }}</span></span>
                  </div>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="消息类型">
                <el-select v-model="searchForm.record_type" @change="selectChange" class="type-select">
                  <el-option
                    v-for="(item, index) in record_typeOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="关键词">
                <el-input
                  v-model="searchForm.content"
                  placeholder="请输入关键词"
                  :disabled="isSearchContent"
                  @input="kong02"
                  @clear="qing"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="时间">
                <el-date-picker
                  ref="date"
                  v-model="searchForm.scopeDate"
                  type="daterange"
                  @change="qing"
                  @blur="closeDate"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options.sync="pickerOptions0"
                  :default-value="Date.now() - 30 * 24 * 3600 * 1000"
                  >
                </el-date-picker>
              </el-form-item>
              <div class="right" style="margin-top: 10px;">
                <el-button
                  class="anniu"
                  type="primary"
                  @click="onSearch(searchForm)"
                  :loading="isdisabled"
                  :disabled="isdisabled"
                  >查询</el-button
                >
              </div>
            </el-form>
            <div class="tao" v-show="tabIndex === 0" @click="reset">
              <img class="fsdfdsf" src="./image/del.png" width="28rem" height="32rem"/>
               <el-tooltip
                class="item"
                effect="dark"
                content="重置后，将清除发送人和接收人所选内容"
                placement="right"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
              <div class="zi">重置</div>
            </div>
          </el-card>
          <div style="display: flex">
            <div class="ty-info">
              <span style="line-height: 32px;">查询条数：</span>
              <span v-if="!isCompute&&showTotal" class="total-num" >{{ total }}条</span>
              <span v-if="isCompute&&showTotal" class="total-num" >数据计算中...</span>
              <el-button  style="margin-left: auto; width: 100px;" class="fr" size="mini"  v-if="!showTotal" type="primary" @click="getTotal()" >点击查看</el-button>
              <!--  <el-tooltip
                  class="item"
                  effect="dark"
                  content="未更改群昵称或外部群聊群主不是内部员工的无法获取群名称只能查看聊天内容"
                  placement="top-start"
                >
                  <i class="el-icon-question" style="color:#8F8F8F;"></i>
                </el-tooltip> -->
            </div>
            <el-button
              style="margin-left: auto; width: 82px;margin-top: 12px;"
              class="fr"
              type="primary"
              size="mini"
              v-auth="['downLoadSession']"
              @click="ExportRecord1"
              v-if="isSearchBtn"
              :disabled="isSearchBtnDisabled"
            >导出</el-button>
          </div>
          <template>
            <el-card class="infinite01" :class="{mui_active: tabIndex === 1}" style="border-bottom: 1px solid #EBEEF5;"
            v-infinite-scroll="handleScroll"
            :infinite-scroll-immediate-check="false"
            :infinite-scroll-throttle-delay="1000"
            :infinite-scroll-distance="10"
            infinite-scroll-disabled="busy">
              <el-collapse v-model="activeNames" accordion v-if="1">
                <el-collapse-item
                  v-for="(list, index) in searchData.data"
                  :key="index"
                  :name="index"
                >
                  <template slot="title">
                    <div class="msg-title" v-if="list.content === '群聊的群聊'" @click="getchat(list.user_id, list.type, list.count_number, index,list.msg_day)">
                      <div style="display: flex;">
                        <img v-if="list.type === 2" src="../../assets/images/qun.png" width="24" height="24" class="icon-msg" />
                        <span>群聊</span>
                        <span class="irn">外部</span>
                      </div>
                      <div class="msg-num">{{ list.count_number }}条相关记录</div>
                    </div>
                    <div v-else class="msg-title" @click="getchat(list.user_id, list.type, list.count_number, index,list.msg_day)">
                      <div style="display: flex;">
                        <img v-if="list.type === 1" src="../../assets/images/ren.png" width="24" height="24" class="icon-msg" />
                        <img v-else-if="list.type === 2" src="../../assets/images/qun.png" width="24" height="24" class="icon-msg" />
                        <span>{{ list.content }}</span>
                        <span v-if="list.suffix && list.suffix === '微信'" style="color: #46BB36FF;">@{{list.suffix}}</span>
                        <span v-if="list.suffix && list.suffix !== '微信'" style="color: #FFC811FF;">@{{list.suffix}}</span>
                        <span v-if="list.type === 1">的私聊</span>
                        <span class="irn" v-if="list.group_type === 2">外部</span>
                      </div>
                      <div class="msg-num">{{ list.count_number }}条相关记录</div>
                    </div>
                  </template>
                  <ul class="gun">
                    <li
                      class="msg-item"
                      v-for="(item, index) in listData"
                      :key="index"
                      @click="chooseDialog(item.msg_id, item.content, item.msg_type, item.action, item.msg_day)"
                    >
                       <template v-if="item === ''">
                        暂无数据
                      </template>
                      <span :class="clientWidth <= 1366 ? 'nmo' : 'nmo01'" v-if="item.is_recall === '1'">[撤回]</span>
                      <template v-if="item.msg_type === 'text'">
                        <div v-if="searchForm.content === undefined">{{ item.content.slice(0, 70) }} </div>
                        <div
                            v-else-if="searchForm.content !== undefined"
                            v-html="strMark(item.content, searchContent)"></div>
                      </template>
                      <div v-if="item.msg_type === 'file'">
                        [文件]
                        <span v-if="searchForm.content === undefined">{{JSON.parse(item.content).filename}}</span>
                        <span v-else v-html="strMark( JSON.parse(item.content).filename, searchContent)"></span>
                      </div>
                      <div v-if="item.msg_type === 'voice'">[语音]</div>
                      <div v-if="item.msg_type === 'chatrecord'">
                        <!-- 转发：{{ JSON.parse(item.content).title }} -->
                        <span v-if="JSON.parse(item.content)">
                        [会话记录]<span v-if="searchForm.content === undefined">{{JSON.parse(item.content).title + '的聊天记录'}}</span>
                        <span v-else v-html="strMark(JSON.parse(item.content).title + '的聊天记录', searchContent)"></span>
                        </span>
                      </div>
                      <div v-if="item.msg_type === 'card'">
                        <span v-if="searchForm.content">
                          <span v-if="JSON.parse(item.content).corpname === '微信' || JSON.parse(item.content).corpname === '微信联系人'">[名片]微信联系人--<span v-html="strMark(JSON.parse(item.content).user_name || '非企业客户', searchContent)"></span></span>
                          <span v-else>[名片]{{JSON.parse(item.content).corpname}}--<span v-html="strMark(JSON.parse(item.content).user_name || '非企业客户', searchContent)"></span></span>
                        </span>
                        <span v-else>
                          <span v-if="JSON.parse(item.content).corpname === '微信' || JSON.parse(item.content).corpname === '微信联系人'">[名片]微信联系人--<span>{{JSON.parse(item.content).user_name || '非企业客户'}}</span></span>
                          <span v-else>[名片]{{JSON.parse(item.content).corpname}}--<span>{{JSON.parse(item.content).user_name || '非企业客户'}}</span></span>
                        </span>
                      </div>
                      <!-- 链接 -->
                      <div v-if="item.msg_type === 'link'">
                        [链接]<span v-if="searchForm.content === undefined">{{JSON.parse(item.content).title}}</span>
                        <span v-else v-html="strMark(JSON.parse(item.content).title,searchContent)"></span>
                      </div>
                      <!-- 同意 -->
                      <div v-if="item.msg_type === 'agree'">
                        [同意]
                      </div>
                      <!-- 小程序 -->
                      <div v-if="item.msg_type === 'weapp'">
                        [小程序]
                        <span>
                          <span v-if="searchForm.content === undefined">{{JSON.parse(item.content).title}}</span>
                          <span v-else v-html="strMark(JSON.parse(item.content).title, searchContent)"></span>
                        </span>
                      </div>
                      <!-- 图片/表情包 -->
                      <template v-if="item.msg_type === 'image'">
                        <div>[图片]</div>
                      </template>
                       <template v-if="item.msg_type === 'emotion'">
                        <div>[表情]</div>
                      </template>
                      <!-- 视频 -->
                      <template v-if="item.msg_type === 'video'">
                        <!-- {{ JSON.parse(item.content).url_path }} -->
                        <div>[视频]</div>
                      </template>
                      <!-- 在线文档 -->
                      <div v-if="item.msg_type === 'docmsg'">
                        [在线文档]<span v-if="searchForm.content === undefined">{{JSON.parse(item.content).title}}</span>
                        <span v-else v-html="strMark(JSON.parse(item.content).title, searchContent)"></span>
                      </div>
                      <!-- 位置 -->
                      <div v-if="item.msg_type === 'location'">
                        [位置]<span v-if="searchForm.content === undefined">{{JSON.parse(item.content).title}}</span>
                        <span v-else v-html="strMark(JSON.parse(item.content).title, searchContent)"></span>
                      </div>
                      <!-- 待办 -->
                      <div v-if="item.msg_type === 'todo'">
                        <li v-if="searchForm.content">
                          [待办]<span v-html="strMark(JSON.parse(item.content).title, searchContent)"></span>--
                          <span v-html="strMark(JSON.parse(item.content).content, searchContent)">
                          </span>
                        </li>
                        <li v-else>
                          [待办]<span>{{JSON.parse(item.content).title}}</span>--
                          <span>{{JSON.parse(item.content).content}}</span>
                        </li>
                      </div>
                      <!-- 会议 -->
                      <div v-if="item.msg_type === 'meeting'">
                        <li>[会议]<span v-if="searchForm.content === undefined">{{JSON.parse(item.content).topic}}</span>
                        <span v-else v-html="strMark( JSON.parse(item.content).topic, searchContent)"></span></li>
                      </div>
                      <!-- 视频号 -->
                      <div v-if="item.msg_type === 'sphfeed'">
                        <li>[视频号]<span v-if="searchForm.content === undefined">{{JSON.parse(item.content).sph_name}}</span>
                        <span v-else v-html="strMark(JSON.parse(item.content).sph_name, searchContent)"></span></li>
                      </div>
                      <!-- 日程 -->
                      <div v-if="item.msg_type === 'calendar'">
                        <li>[日程]<span v-if="searchForm.content === undefined">{{JSON.parse(item.content).title}}</span>
                        <span v-else v-html="strMark(JSON.parse(item.content).title, searchContent)"></span></li>
                      </div>
                      <!-- 投票 -->
                      <div v-if="item.msg_type === 'vote'">
                        <li class="info-title">
                          [投票]<span v-html="strMark(JSON.parse(item.content).votetitle, searchContent)"></span>
                        </li>
                      </div>
                      <!-- 填表 -->
                      <div v-if="item.msg_type === 'collect'">
                        [填表]<span v-if="searchForm.content === undefined">{{JSON.parse(item.content).title}}</span>
                        <span v-esle v-html="strMark(JSON.parse(item.content).title, searchContent)"></span>
                      </div>
                      <!-- 红包 -->
                      <div v-if="item.msg_type === 'redpacket'">
                        [红包]
                      </div>
                      <div v-if="item.msg_type === 'external_redpacket'">
                        [红包]
                      </div>
                      <!-- 音频存档消息 -->
                      <div v-else-if="item.msg_type === 'meeting_voice_call'">
                        [语音通话]
                      </div>
                       <!-- 不同意会话存档消息 -->
                      <div v-else-if="item.msg_type === 'disagree'">
                        [不同意]
                      </div>
                      <!-- 音频共享文档消息 -->
                      <div v-else-if="item.msg_type === 'voip_doc_share'">
                        <div>
                          <span class="filename">
                          <span v-if="searchForm.content === undefined">
                          {{ JSON.parse(item.content).filename.substring(0, JSON.parse(item.content).filename.lastIndexOf('.'))}}</span>
                          <span v-else v-html="strMark(JSON.parse(item.content).filename.substring(0, JSON.parse(item.content).filename.lastIndexOf('.')), searchContent)"></span></span
                          ><br />
                          <span class="file-desc">演示文档</span>
                        </div>
                      </div>
                      <!-- 混合消息 -->
                      <div v-if="item.msg_type === 'mixed'">
                        [混合消息]<span v-for="(k, index) in JSON.parse(item.content).item" :key="index">
<!--                        <span v-if="k.type === 'text'" v-html="strMark(JSON.parse(k.content).content, searchForm.content)">-->
                        <span v-if="k.type === 'text'" v-html="strMark(JSON.parse(k.content).content, searchContent)">
                          <span v-if="JSON.parse(k.content).content.length > 35">...</span>
                        </span>
                        <span v-else-if="k.type === 'image'">[图片]</span>
                        <span v-else-if="k.type === 'emotion'">[表情]</span>
                        </span>
                      </div>
                      <template v-if="item.msg_type === 'revoke'">
                        <span :class="clientWidth <= 1366 ? 'nmo' : 'nmo01'">[撤回]</span>
                        <div><span v-if="searchForm.content" v-html="strMark(item.remarks, searchContent)"></span><span v-else>{{item.remarks}}</span></div>
                      </template>
                      <div class="time"> {{ item.msg_dateTime.slice(0, 11) }}</div>
                    </li>
                  </ul>
                </el-collapse-item>
              </el-collapse>

              <div v-if="showEmpty">
                <div class="none-data">
                  <img src="../../assets/images/img-none.png" alt="暂无数据" width="200" />
                  <p>暂无数据</p>
                </div>
              </div>
            </el-card>
          </template>
        </el-col>
        <el-col :span="14">
          <el-card class="box-card dialog-card">
            <div slot="header">
              <el-divider class="fenge" direction="vertical"></el-divider>
              <span
                style="color: #204A9E;
                font-size: 18px;
                line-height: 28px;
                font-family: Source Han Sans CN;
                font-weight: 600;"
                >消息记录</span
              >
              <!-- 1.2 -->
              <!-- <el-button style="float: right; " plain size="mini" @click="getEandomMsg">
                更多
              </el-button> -->
              <el-button
                style="margin-left: 20px; width: 122px;"
                class="fr"
                type="primary"
                size="mini"
                v-auth="['downLoadSession']"
                @click="ExportRecord2"
                v-if="isSearchBtn"
                :disabled="isSearchBtnDisabled1"
                >导出当前记录</el-button
              >
<!--              <el-button-->
<!--                class="fr"-->
<!--                type="primary"-->
<!--                size="mini"-->
<!--                @click="getEand"-->
<!--                v-if="isMoreBtn"-->
<!--                :disabled="!isRandomMsg"-->
<!--              >更多</el-button-->
<!--              >-->
            </div>
            <div class="msg-tab" style="padding-left: 30px;padding-right: 50px;">
              <template v-if="msgId">
                <chat
                  :msgId="msgId"
                  :maskText="maskText"
                  :content="searchContent"
                  :isMask="searchContent ? false : true"
                  :msgDay="msgDay"
                ></chat>
              </template>
              <div class="none-data" v-else>
                <img src="../../assets/images/img-none.png" alt="暂无数据" width="200" />
                <p>暂无数据</p>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <selectDepPers
      :isShow.sync="isDepartmentDialog"
      @check-user="checkUser"
      @check-dep="checkDep"
      :isMultiple="false"
      :checkeds="checkedEmployees"
      :checkedDeps="checkedDepartments"
    ></selectDepPers>
    <selectDepPers
      :isShow.sync="isDepartment"
      @check-user="getDepart"
      @check-dep="getStafftDep"
      :isMultiple="false"
      :checkeds="showjv"
      :checkedDeps="checkedStafftDep"
    ></selectDepPers>
    <!--<Section
      :isShow="isDepartment"
      @check-user="getDepart"
      @check-dep="getStafftDep"
      :isMultiple="false"
      :checkedss="showjv"
      :checkedDeps="checkedStafftDep"
      v-if="isDepartment"
    ></Section>-->
  </div>
</template>
<script>
  import { index } from './index.js'
  export default { mixins: [index] }
</script>
<style lang="scss" scoped>
  @import "./index.scss";
</style>
